import { ScrollReveal } from "./components/ScrollReveal";
import Hero from "./components/Hero";
import Navbar from "./components/Navbar";
import SectionTitle from "./components/SectionTitle";
import Container from "./components/Container";
import { SplitContrastCard } from "./components/Infographic";

import { benefitOne, benefitTwo } from "./components/data";
import Video from "./components/Video";
import Benefits from "./components/Benefits";
import Footer from "./components/Footer";
import UseCases from "./components/UseCases";
import Cta from "./components/CTA";
import Faq from "./components/FAQ";
// import PopupWidget from "../components/popupWidget";

const Home = () => {
  // Only redirect to production site when deployed elsewhere (e.g. old URL), not in local dev
  if (
    process.env.NODE_ENV === "production" &&
    !window.location.hostname.includes("leadzlab.co")
  ) {
    window.location.href = "https://leadzlab.co";
    return null;
  }
  return (
    <>
      <Navbar />
      <Hero />
      <div id="demo" className="bg-slate-50/50 pt-2" aria-hidden>
        {/* Soft transition from hero */}
      </div>
      <section className="bg-slate-50/50 pb-2">
        <ScrollReveal>
          <SectionTitle
            pretitle="See how it works"
            title="How LeadZLab works in 3 steps"
          >
            Set your skills and topics. Get live conversations from Reddit and
            LinkedIn that match. Reach out first—before it becomes a job post.
          </SectionTitle>
        </ScrollReveal>
        <ScrollReveal>
          <Video />
        </ScrollReveal>
      </section>
      <ScrollReveal>
        <SectionTitle
          pretitle="Why LeadZLab"
          title="Freelance platforms are crowded."
        >
          Your next client is already asking for help.
        </SectionTitle>
      </ScrollReveal>
      <ScrollReveal>
        <Container className="py-6 lg:py-8">
          <SplitContrastCard />
        </Container>
      </ScrollReveal>
      <ScrollReveal>
        <Benefits data={benefitOne} />
      </ScrollReveal>
      <ScrollReveal>
        <Benefits imgPos="right" data={benefitTwo} />
      </ScrollReveal>
      <span id="use-cases"> </span>

      <ScrollReveal>
        <SectionTitle
          pretitle="Use cases"
          title="Who uses LeadZLab"
        >
          Freelancers who’d rather respond to real conversations than fight over
          job listings.
        </SectionTitle>
      </ScrollReveal>
      <UseCases />

      <ScrollReveal>
        <SectionTitle pretitle="FAQ" title="Frequently asked questions" />
      </ScrollReveal>
      <Faq />
      <ScrollReveal>
        <Cta />
      </ScrollReveal>
      <ScrollReveal>
        <Footer />
      </ScrollReveal>
      {/* <PopupWidget /> */}
    </>
  );
};

export default Home;
